

export default function IdOptions({ config, update }) {

	return <div className='FieldOptions FieldOptionsCustom'>

	</div>
}